/**
 * @generated SignedSource<<150cdbd75ae2b51374dc0feb353a383c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
export type DurationPlayerRateControlQuery$variables = {
  bookingId: string;
  duration?: number | null | undefined;
  groupSize?: number | null | undefined;
  membershipTypeId: string;
};
export type DurationPlayerRateControlQuery$data = {
  readonly node: {
    readonly startSlot?: {
      readonly id: string;
      readonly playerRates?: ReadonlyArray<{
        readonly rate: {
          readonly appliesToMembershipType: boolean | null | undefined;
          readonly customerTypes?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly additionalInfo: string | null | undefined;
                readonly id: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly visibility: VisibilityStatus;
        };
        readonly totalDurationPrice: number | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type DurationPlayerRateControlQuery = {
  response: DurationPlayerRateControlQuery$data;
  variables: DurationPlayerRateControlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duration"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bookingId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "highestPrecedentOnly",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "CUSTOMER"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "membershipTypeId",
      "variableName": "membershipTypeId"
    }
  ],
  "kind": "ScalarField",
  "name": "appliesToMembershipType",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerTypeConnection",
      "kind": "LinkedField",
      "name": "customerTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomerTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomerType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "additionalInfo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CustomerRate",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "duration",
      "variableName": "duration"
    },
    {
      "kind": "Variable",
      "name": "playerCount",
      "variableName": "groupSize"
    }
  ],
  "kind": "ScalarField",
  "name": "totalDurationPrice",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DurationPlayerRateControlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "playerRates",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": "playerRates(highestPrecedentOnly:false,type:\"CUSTOMER\")"
                      }
                    ],
                    "type": "TimeSlot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "DurationPlayerRateControlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "playerRates",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v5/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": "playerRates(highestPrecedentOnly:false,type:\"CUSTOMER\")"
                      }
                    ],
                    "type": "TimeSlot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "06916344474ceba9f1b78b87c4badaa3",
    "id": null,
    "metadata": {},
    "name": "DurationPlayerRateControlQuery",
    "operationKind": "query",
    "text": "query DurationPlayerRateControlQuery(\n  $bookingId: ID!\n  $membershipTypeId: ID!\n  $duration: Int\n  $groupSize: Int\n) {\n  node(id: $bookingId) {\n    __typename\n    ... on Booking {\n      __isBooking: __typename\n      startSlot {\n        __typename\n        id\n        ... on TimeSlot {\n          playerRates(highestPrecedentOnly: false, type: CUSTOMER) {\n            rate {\n              __typename\n              id\n              name\n              visibility\n              appliesToMembershipType(membershipTypeId: $membershipTypeId)\n              ... on CustomerRate {\n                customerTypes {\n                  edges {\n                    node {\n                      id\n                      additionalInfo\n                    }\n                  }\n                }\n              }\n            }\n            totalDurationPrice(duration: $duration, playerCount: $groupSize)\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "82481b29ce4061dc154c2eb6cb018523";

export default node;
